<template>
    <div :id="'radio--' + component_id">
        <div class="designeroption" v-if="options_loaded && passed_filter" :data-designer-component-id="component_id">
            <h3>Add Secured By Design To Your Door</h3>
            <div class="stylesoption">
                <div class="align-center p-3">
                    <img :src="'/images/wb/sbd.png'" alt="">
                </div>
                <div class="sbd-radio-wrapper">
                    <label>Would you like to upgrade to SBD?</label>
                    <div class="radios _inline">
                        <div v-for="option in filtered_option_list" class="radio">
                            <label>
                                <input type="radio" v-model="localTarget" :name="'radio_' + component_id" :value="option.value"/>
                                <span class="radio-label">{{ option.label }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSecuredByDesign from "../DesignerQuestionSecuredByDesign.vue";

    export default {
        mixins: [
            DesignerQuestionSecuredByDesign
        ],
    }
</script>
